import { Button } from '@amzn/meridian';
import { type FC, useState } from 'react';
import { TPShareModal } from '../TPShareModal/TPShareModal';

export type TPShareButtonProps = {
  projectId: string;
};
export const TPShareButton: FC<TPShareButtonProps> = ({ projectId }) => {
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(false);
  const onClickShareButton = () => setOpen(true);
  const onClose = () => setOpen(false);

  return (
    <>
      <Button onClick={onClickShareButton} onMouseEnter={() => setHovered(true)}>
        Share project
      </Button>
      <TPShareModal onClose={onClose} open={open} projectId={projectId} skipQuery={!hovered && !open} />
    </>
  );
};
